// Shared PIN length + validation helpers used across the PIN dialogs and PinInput.

export const PIN_LENGTH = 4;

const PIN_PATTERN = new RegExp(`^\\d{${PIN_LENGTH}}$`);

/** True when `value` is a complete, all-numeric PIN of the expected length. */
export function isPinComplete(value: string): boolean {
  return PIN_PATTERN.test(value);
}
